export const decodeCouponDiscount = (discount, coupon = {}) => {
  const raw = String(discount ?? "").trim();
  const isPercentage =
    coupon?.discountType === "percentage" ||
    Boolean(coupon?.percentage) ||
    raw.endsWith("%");
  const value = Number(raw.replace(/%/g, "").trim());

  return {
    value: Number.isFinite(value) ? value : 0,
    isPercentage,
  };
};

export const encodeCouponDiscount = (value, isPercentage) => {
  const num = Number(value);
  if (!Number.isFinite(num) || num <= 0) return "";
  return isPercentage ? `${num}%` : String(num);
};

export const getCouponValue = (coupon) => {
  if (!coupon) return 0;
  const raw = coupon.value ?? coupon.discount;
  return decodeCouponDiscount(raw, coupon).value;
};

export const isPercentageCoupon = (coupon) => {
  if (!coupon) return false;
  return decodeCouponDiscount(coupon.discount ?? coupon.value, coupon).isPercentage;
};

export const normalizeAppliedCoupon = (coupon) => {
  if (!coupon || typeof coupon !== "object") return {};

  const { value, isPercentage } = decodeCouponDiscount(
    coupon.discount ?? coupon.value,
    coupon
  );
  if (!value) return {};

  const discountAmount = Number(coupon.discountAmount);

  return {
    ...coupon,
    code: coupon.code || coupon.promoCode,
    promoCode: coupon.promoCode || coupon.code,
    value,
    discount: coupon.discount ?? encodeCouponDiscount(value, isPercentage),
    percentage: isPercentage,
    discountType: isPercentage ? "percentage" : "fixed",
    discountAmount: Number.isFinite(discountAmount) ? discountAmount : undefined,
    source: coupon.source || "local",
    tevoPromotionId: coupon.tevoPromotionId || null,
    name: coupon.name || null,
  };
};

export const getDiscountAmount = (totalAmount, coupon) => {
  const normalized = normalizeAppliedCoupon(coupon);
  if (!normalized.value) return 0;

  if (Number.isFinite(normalized.discountAmount)) {
    return normalized.discountAmount;
  }

  const total = totalAmount || 0;
  if (normalized.percentage) {
    return (normalized.value * total) / 100;
  }
  return Math.min(normalized.value, total);
};

export const getDiscountedTotal = (totalAmount, coupon) => {
  const total = totalAmount || 0;
  const discountAmount = getDiscountAmount(total, coupon);
  if (!discountAmount) {
    return total;
  }
  return Math.max(total - discountAmount, 0);
};

export const formatCouponDiscount = (coupon) => {
  const normalized = normalizeAppliedCoupon(coupon);
  const value = normalized.value;
  if (!value) return "$0";

  if (normalized.percentage) {
    if (Number.isFinite(normalized.discountAmount) && normalized.discountAmount > 0) {
      return `-$${normalized.discountAmount.toFixed(2)} (${value}%)`;
    }
    return `${value}%`;
  }

  return `-$${value}`;
};
